package br.com.vvrefeicoes.portal.domain.model

data class UserImportRow(
    val name: String,
    val email: String,
    val sector: String,
    val cargo: String,
    val phone: String,
)

data class UserImportResult(
    val totalRows: Int,
    val created: Int,
    val skippedMissingEmail: Int,
    val skippedDuplicate: Int,
    val skippedExisting: Int,
    val invalid: Int,
    val errors: List<String> = emptyList(),
)

data class UserImportPreview(
    val totalRows: Int,
    val ready: Int,
    val skippedMissingEmail: Int,
    val skippedDuplicate: Int,
    val skippedExisting: Int,
    val invalid: Int,
)
